function change_country(select_element) {
  var url = select_element.value;
  var open_target = select_element.getAttribute('data-open-target');
  
  if (open_target === "new_tab") {
    window.open(url, "_blank");
    // Reset dropdown to default after opening new tab
    select_element.selectedIndex = 0;
  } else {
    window.location.href = url;
  }
}

// Reset the dropdown to default on initial load
document.addEventListener("DOMContentLoaded", function() {
  var selector = document.getElementById("country-selector");
  if (selector) {
    selector.selectedIndex = 0;
  }
});

// Reset the dropdown to default when the page is shown (handles back button / bfcache)
window.addEventListener("pageshow", function(event) {
  var selector = document.getElementById("country-selector");
  if (selector) {
    selector.selectedIndex = 0;
  }
});